import apiInterface from "./apiInterface";
import { post, get } from "./axiosConfig";
import VueCookie from "vue-cookie";
import enumInfo from "./enum";
import moment from "moment"; //时间控件
import qs from "qs";
import { i18n, translate as $t } from '../language/i18n_mounting'
import { MessageBox } from 'element-ui';
const $enumInfo = enumInfo.cardhobby

var lang = VueCookie.get('CardLang') || 'en'
moment.locale(lang);

const domain = process.env.NODE_DOMAIN;
//倒计时 分享
export function shareTime(itemEnd, nowData, type) {
  var end = new Date(itemEnd).getTime() + 24 * 60 * 60 * 1000; //获取列表传的截止时间，转成时间戳
  var now = nowData; //获取当前时间
  //时间差
  var rightTime = end - now; //截止时间减去当前时间
  //console.log(rightTime)
  if (rightTime > 0) {
    //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
    var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24) - 1;
    var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
    var mm = Math.floor((rightTime / 1000 / 60) % 60);
    var ss = Math.floor((rightTime / 1000) % 60);
    let res =
      NuberZero(dd) +
      "," +
      NuberZero(hh) +
      "," +
      NuberZero(mm) +
      "," +
      NuberZero(ss);
    if (dd <= -1) {
      res = "00,00,00,00";
    }
    return res;
  } else {
    return "00,00,00,00";
  }
}
// 给单数时间加零 , 1=>01
export function NuberZero(val) {
  if (Number(val) < 10) {
    return "0" + val;
  } else {
    return val;
  }
}
// 鸽子倒计时
export function doveCountDown(itemEnd) {
  if (itemEnd > 0) {
    var rightTime = itemEnd
    var dd = Math.floor(rightTime / 60 / 60 / 24);
    var hh = Math.floor((rightTime / 60 / 60) % 24);
    var mm = Math.floor((rightTime / 60) % 60);
    var ss = Math.floor((rightTime) % 60);
    let res = "";
    if (dd > 0) {
      res = dd + "d " + hh + "h";
    } else if (hh > 0 && dd == 0) {
      res = hh + "h " + mm + "m";
    } else if (mm >= 1 && hh == 0 && dd == 0) {
      res = mm + "m " + ss + "s";
    } else if (mm < 1 && ss != 0 && hh == 0 && dd == 0) {
      res = ss + "s";
    } else if (dd <= -1 || ss == 0) {
      return "00:00";
    }
    return res;
  }
}
//倒计时
export function countDown(itemEnd, nowData, type) {
  //Ended listing
  if (itemEnd == "Ended listing") {
    return "00:00";
  } else {
    //console.log(itemEnd,'itemEnd')
    var end = new Date(itemEnd).getTime() + 24 * 60 * 60 * 1000; //获取列表传的截止时间，转成时间戳
    var now = nowData; //获取当前时间
    //时间差
    var rightTime = end - now; //截止时间减去当前时间
    //console.log(rightTime)
    if (rightTime > 0) {
      //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
      var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24) - 1;
      var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
      var mm = Math.floor((rightTime / 1000 / 60) % 60);
      var ss = Math.floor((rightTime / 1000) % 60);
      let res = "";
      // console.log(type)
      // type   1:倒计时结束或者倒计时结束前1小时 , 0:其他
      if (type != undefined && (type == 1 || type == 0)) {
        //console.log(dd,hh,mm,ss)
        if (dd > 0) {
          return 0;
        } else if (hh > 0 && dd == 0) {
          return 0;
        } else if (mm >= 1 && hh == 0 && dd == 0) { //1小时以内
          return 1;
        } else if (mm < 1 && ss != 0 && hh == 0 && dd == 0) { //1分钟以内
          return 1;
        } else if (dd <= -1 || ss == 0) {
          return 1;
        } else {
          return 0;
        }
      } else if (type == 2) {
        if (dd > 0) {
          return 0;
        } else if (hh > 0 && dd == 0) {
          return 0;
        } else if (mm >= 1 && hh == 0 && dd == 0) { //1小时以内
          return 0;
        } else if (mm < 1 && ss != 0 && hh == 0 && dd == 0) { //1分钟以内
          return 1;
        } else if (dd <= -1 || ss == 0) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (dd > 0) {
          res = dd + "d " + hh + "h";
        } else if (hh > 0 && dd == 0) {
          res = hh + "h " + mm + "m";
        } else if (mm >= 1 && hh == 0 && dd == 0) {
          res = mm + "m " + ss + "s";
        } else if (mm < 1 && ss != 0 && hh == 0 && dd == 0) {
          res = ss + "s";
        } else if (dd <= -1 || ss == 0) {
          return "00:00";
        }
        return res;
      }
    } else {
      if (type != undefined) {
        return 1;
      } else {
        return "00:00";
      }
    }
  }
}
// 获取美元实时汇率
export function GetWorldUSD() {
  get(apiInterface.Interface.GetUSD, '').then(res => {
    //console.log(res,1)
    //config.params.token=res.data.Data.Token
    const domain = process.env.NODE_DOMAIN
    let time = new Date(new Date().getTime() + 0.5 * 60 * 60 * 1000)
    let data = { 'u': res.data['Usd'], 'c': res.data['Additional'] }
    //console.log(data, 'GetWorldUSD')
    VueCookie.set('CardExchange', JSON.stringify(data), { domain: domain, expires: time });
  })
}
// 获取當前買家实时汇率
export function GetWorldBUYUSD(obj) {
  var MemberSource = obj
  if (obj != 'MO') {
    MemberSource = 'US'
  }
  let data = { memberSource: MemberSource }
  get(apiInterface.Interface.GetExchangeRate, data).then(res => {
    //console.log(res,1)
    //config.params.token=res.data.Data.Token
    const domain = process.env.NODE_DOMAIN
    let time = new Date(new Date().getTime() + 0.5 * 60 * 60 * 1000)
    let data = { 'u': res.data['Usd'], 'c': res.data['Additional'] }
    //console.log(data, 'GetWorldUSD')
    VueCookie.set('CardExchange', JSON.stringify(data), { domain: domain, expires: time });
  })
}
// 判断数字是否存在千分位
export function isNumber(val) {
  //console.log(val, Number(val).toString(), "Number(val).toString()");
  var val = Number(val).toString() != "NaN" ? Number(val) : Number(val.replace(/,/gi, ""));
  return val
}
// 输出：1,234,567.89
// 判断数字是否存在千分位
export function formatAmount(val) {
  //console.log(val, Number(val).toString(), "Number(val).toString()");
  var val = isNumber(val)
  val = val.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return val
}

// 判断本地邮费
/**
 * 
 *  userinfo: 用户详情,
 *  custom: 邮件模板,
 *  souerce: 卖家国籍,
 *  type: 1:官方商城,0:普通商品,
 * 
 **/
export function isUserDomest(userinfo, custom, source, type) {
  let price = {};
  let data = custom
  let num = 0
  //console.log(userinfo, 'userinfo|', custom, 'custom|', source, 'source|', type, 'type')
  //@todo 賣家所在地為US 買家所在地非US userinfo.StateCode 改成CA
  // if (userinfo && ((userinfo.StateCode == undefined && source != "CN") || (userinfo.MemberSource != source && source != "CN"))) {
  //   userinfo.State = "California"
  // }
  var MemberSource = userinfo.MemberSource || userinfo.Country
  // if (userinfo && source == "US" && (MemberSource != source)) {
  //   userinfo.State = "California"
  // }
  //判断邮费模板所在地
  try {
    if (userinfo != null) {
      var city = userinfo.city || userinfo.State
      var state = userinfo.State || userinfo.city

      if (type != null && source != 'CN') {
        state = type.Provice
      }
      if (userinfo.AreaId == 'CN') {
        city = '上海'
      }
      let aid = source == "CN" ? city : '、' + state.toLowerCase() + '、'
      data.map(res => {
        let areaID = source == "CN" ? res.AreaName : '、' + res.AreaName.toLowerCase() + '、'
        //console.log(aid, areaID, 'aid,areaID')
        if (areaID.indexOf(aid) != -1) {
          num++;
          price = res
        }
      })
    }
  } catch (error) {}
  if (num == 0) {
    price = data[0]
  }
  console.log(price, userinfo, source, custom,'price')
  return price
}
// 判断官方商城邮费
/**
 * 
 *  userinfo: 用户详情,
 *  custom: 邮件模板
 * 
 **/
export function isStoreDomest(userinfo, custom) {
  //console.log(userinfo, custom,'123123')
  let customDetail = custom.Details
  let price = { "CostType": customDetail[0].CostType, "FreeDelivery": customDetail[0].FreeDelivery, "DetailMinimumAmount": customDetail[0].DetailMinimumAmount, "Cost": customDetail[0].Cost };
  if (userinfo && userinfo.State) {
    let ProvinceName = userinfo.State
    //console.log(custom,customDetail,'customDetail')
    if (customDetail) {
      var newPrice = customDetail.filter(res => {
        return res.ProvinceName == ProvinceName
      })
      if (newPrice.length > 0) {
        price = newPrice[0]
      }
      //console.log(price,'price')
    }
  }
  return price
}
//是否登录
export function getInfo() {
  let info = VueCookie.get("cardUser");
  // console.log('info', info)
  if (info != null && info.length > 0) {
    return JSON.parse(info);
  } else {
    return null;
  }
}
// 判断是否是数字
export function isNum(val) {
  var regu = /^(\-|\+)?\d+(\.\d+)?$/;
  return regu.test(val)
}
//设置用户信息
export function setInfo(key, val) {
  let info = VueCookie.get("cardUser");
  info = JSON.parse(info);
  info[key] = val;
  let time = new Date(new Date().getTime() + 96 * 60 * 60 * 1000);
  VueCookie.set("cardUser", JSON.stringify(info), {
    domain: domain,
    expires: time
  });
}
//获取用户信息 type: 0：同步用户信息 ,1:登录，2：注册
export function getUser(val, type) {
  let that = this;
  let data = {
    memberid: val.MappingUserId,
    token: val.ChineseToken,
    operator_id: val.MappingUserId
  };
  window.localStorage.setItem('toa', val.MappingUserId)
  get(apiInterface.Interface.GetUserDetail, data).then(res => {
    if (res.result != 0) {
      let data = res.data;
      val.PointCount = data.PointCount || 0;
      val.SumMoney = data.SumMoney || 0;
      val.HeadPortrait = data.HeadPortrait || "";
      val.MemberSource = data.MemberSource || "";
      val.WyAccId = data.WyAccId || val.MappingUserId;
      val.WyToken = data.WyToken || 0;
      val.VerifyStatus = data.VerifyStatus || 0;
      val.IsSell=data.IsSell;
      //获取用户地址列表
      get(apiInterface.Interface.SearchShippingAddresses, {
        MemberId: val.Id,
        PageIndex: 1,
        PageSize: 10
      }).then(rs => {
        val.Count = rs.Count || 0;
        // 2022/12/7
        if (val.Count > 0) {
          val.State = rs.Data[0].State
          val.StateCode = rs.Data[0].StateCode
          val.address = rs.Data[0]
        }
        //
        let time = new Date(new Date().getTime() + 96 * 60 * 60 * 1000);
        VueCookie.set("cardUser", JSON.stringify(val), {
          domain: domain,
          expires: time
        });
        //console.log("typetype", type)
        if (type != 0 || type == undefined) {
          VueCookie.delete("CardAuth", { domain: domain });
          // 根据买家MemberSource获取汇率
          //GetWorldBUYUSD(val.MemberSource)
          //判断是否存在后退页面的存在
          let url = window.localStorage.getItem("toLink");
          let toa = window.localStorage.getItem("toa");
          if (toa == val.MappingUserId) {
            //判断是否为ie浏览器
            let browser = window.navigator.userAgent;
            if (browser.indexOf("Trident") >= 0) {
              window.location.href = "/";
            } else {
              window.location.href = url ? url : "/";
            }
          } else {
            window.location.href = "/";
          }
          window.localStorage.removeItem("toLink");
          window.localStorage.removeItem("toa");
        } else if (type == 0) {
          return true;
        }
      });
    } else {
      that.$message({
        type: "error",
        duration: 1000,
        message: res.msg
      });
    }
  });
}
export function setIDForOther(obj, type) {
  let that = this
  if (obj) {
    post(apiInterface.Interface.CreateIDForOther, { Id: obj.MappingUserId }).then(res => {
      if (res.Result) {
        var url = res.Data.web.href
        //return url
        //console.log(url)
        window.location.href = url;
      } else {
        return true
        that.$message({
          type: "error",
          duration: 1000,
          message: res.msg
        });
      }
    })
  }

}
// GetUserDetail
//打码email
// val => email地址
export function CensoredEmail(val) {
  let str = val;
  str = str.split("@");
  if (str[0].length <= 3) {
    str[0] = str[0].substr(0, 1);
  } else {
    str[0] = str[0].substr(0, 3);
  }
  return str[0] + "*********@" + str[1];
}
export function isToken() {
  var token = VueCookie.get("CardHobbyToken") || "";
  if (!token) {
    post(apiInterface.Interface.GetToken, {
      appId: "CardHobbyWeb",
      appSecret: "CardHobbyWeb"
    }).then(res => {
      let time = new Date(new Date().getTime() + 1 * 60 * 60 * 1000);
      VueCookie.set("CardHobbyToken", res.Data.Token, { expires: time });
    });
  }
}
//快捷分类显示  分类结构重组
export function resetMarketEntry(val) {
  let data = [];
  val.map(res => {
    data = [...data, ...res];
  });
  return data;
}
//三级分类显示  分类结构重组
// Category => 传入类目的值
// type => card:官方商城
export function resetCategory(Category, type) {
  //分类结构重组 [{'id':1,'label':'卡片','children':[{'id':1,'label':'影视卡','children':[....]}]}]
  var ctg = [];
  Category.map(function(o, k) {
    //重组一级分类
    var f = o["FirstCategory"]["Category"];
    var label = {
      id: f["_id"],
      label: f["ChName"],
      EnName: f["EnName"],
      children: []
    };
    if (type == "card") {
      //console.log('label.id', f["ID"])
      label.id = f["ID"];
    }
    ctg.push(label);
    //重组二级分类
    o["FirstCategory"]["SecondCategories"].map(function(oo, kk) {
      var ooData = {
        id: oo["Category"]["_id"],
        label: oo["Category"]["ChName"],
        EnName: oo["Category"]["EnName"],
        Fid: f["_id"],
        children: []
      };
      if (type == "card") {
        ooData.id = oo["Category"]["ID"];
        ooData.Fid = f["ID"];
      }
      ctg[k]["children"].push(ooData);
      //重组三级分类
      oo["ThirdCategories"].map(function(ooo, kkk) {
        var oooData = {
          id: ooo["Category"]["_id"],
          label: ooo["Category"]["ChName"],
          ChName: ooo["Category"]["ChName"],
          EnName: ooo["Category"]["EnName"],
          FCName: f["ChName"],
          FEName: f["EnName"],
          Fid: f["_id"],
          SCName: oo["Category"]["ChName"],
          SEName: oo["Category"]["EnName"],
          Sid: oo["Category"]["_id"],
          Properties: ooo["CategoryProperties"],
          children: []
        };
        if (type == "card") {
          oooData.id = ooo["Category"]["ID"];
          oooData.Fid = f["ID"];
          oooData.Sid = oo["Category"]["ID"];
        }
        ctg[k]["children"][kk]["children"].push(oooData);
      });
    });
  });
  return ctg;
}

//三级分类显示官方商城  分类结构重组
// Category => 传入类目的值
/**
 * 重置商品分类数据结构
 * @param {Object} Category - 原始分类数据对象
 * @param {Array} CategoryName - 分类名称数组,包含三级分类的key名
 * @returns {Array} 重构后的分类数据数组
 * @description 将原始的多层级分类数据重构为统一的Childs结构:
 * - 第一级保持不变
 * - 第二级重命名为Childs
 * - 第三级分为Childs和Childs2两类
 *   - 有LeiBie属性的放入Childs2
 *   - 无LeiBie属性的放入Childs
 */
export function resetStoreCategory(Category, CategoryName) {
  let data = Category[CategoryName[0]]
  data.map((f, i) => {
    //var child=f[CategoryName[1]]
    for (var key in f) {
      //console.log(key,CategoryName[1])
      if (key == CategoryName[1]) {
        f = Object.assign(f, { 'Childs': f[CategoryName[1]] })
        if (f[key]) {
          f[key].map(s => {
            for (var name in s) {
              if (name == CategoryName[2]) {
                let Childs = []
                let Childs2 = []
                if (!s[CategoryName[2]]) {
                  s = Object.assign(s, { 'Childs': Childs })
                  s = Object.assign(s, { 'Childs2': Childs2 })
                } else {
                  s[CategoryName[2]].map(r => {
                    if (r.LeiBie) {
                      Childs2.push(r)
                    } else {
                      Childs.push(r)
                    }
                  })
                  s = Object.assign(s, { 'Childs': Childs })
                  s = Object.assign(s, { 'Childs2': Childs2 })
                }
              }
            }
            delete(s[CategoryName[2]])
          })
        }
      }
    }

    delete(f[CategoryName[1]])
    //console.log(f, data, CategoryName, 'Category')
  })
  return data
}

//获取地址列表
export function addressList() {
  let info = VueCookie.get("cardUser");
  let data = { MemberId: JSON.parse(info).Id, PageIndex: 1, PageSize: 10 };
  return get(apiInterface.Interface.SearchShippingAddresses, data);
}
//获取类目列表
export function getCategory() {
  return get(apiInterface.Interface.GetCategories, "");
}
//获取官方商城类目列表
export function GetyCategories() {
  return get(apiInterface.Interface.GetCategoryCache, "");
}

//把类目列表放入缓存,由于cookies大小不够，所以放在本地缓存里面，用cookies
// type => get,set
// key => 本地缓存的key
// val => 存入本地缓存的key
// fun => 作用就是return
/**
 * 处理分类数据的缓存和获取
 * @param {string} type - 操作类型，'get' 获取数据或 'set' 设置数据
 * @param {string} key - cookie键名
 * @param {string} val - 本地存储键名，可选值: 'shop'|'card'|'entry'
 * @param {Function} fun - 回调函数，用于处理获取到的数据
 * @description 根据不同类型(shop/card/entry)获取对应分类数据，并进行本地存储。
 * 数据有效期为5小时，通过cookie进行控制。
 * 当获取失败或数据不存在时，会自动触发设置操作。
 */
export function CookiesCategory(type, key, val, fun) {
  if (type == "get") {
    let isCategory = VueCookie.get("cardCategory");
    if (isCategory != 0 && isCategory != null) {
      try {
        let valList = window.localStorage.getItem(val);
        valList = JSON.parse(valList);
        if (valList == null) {
          type = "set";
        } else {
          new fun(valList);
        }
      } catch (err) {
        type = "set";
      }
    } else {
      type = "set";
    }
  }
  if (type == "set") {
    let time = new Date(new Date().getTime() + 5 * 60 * 60 * 1000);
    VueCookie.set("cardCategory", 1, { expires: time });
    if (val == "shop") {
      getCategory().then(res => {
        if (res.Result != 0) {
          if(res.Data){
            let result = resetCategory(res.Data);
            window.localStorage.setItem(val, JSON.stringify(result));
            new fun(result);
          }
        }
      });
    } else if (val == "card") {
      GetyCategories().then(res => {
        if (res.result != 0) {
          if(res.data){
            let result = resetCategory(res.data, "card");
            window.localStorage.setItem(val, JSON.stringify(result));
            new fun(result);
          }
        }
      });
    } else if (val == "entry") {
      let data = { Area: "US" };
      get(apiInterface.Interface.GetMarketEntryAllListByAreaId, data).then(
        res => {
          if (res.Result != 0) {
            let result = resetMarketEntry(res.Data);
            //that.sports=resetMarketEntry(res.Data)
            window.localStorage.setItem(val, JSON.stringify(result));
            new fun(result);
          }
        }
      );
    }
  }
}

export function setCookiesCategory() {
  getCategory().then(res => {
    if (res.Result != 0) {
      if(res.Data){
        let result = resetCategory(res.Data);
        window.localStorage.setItem("shop", JSON.stringify(result));
      }
    }
  });
  GetyCategories().then(res => {
    if (res.result != 0) {
      if(res.data){
        let result = resetCategory(res.data, "card");
        window.localStorage.setItem("card", JSON.stringify(result));
      }
    }
  });
  let data = { Area: "US" };
  get(apiInterface.Interface.GetMarketEntryAllListByAreaId, data).then(res => {
    if (res.Result != 0) {
      let result = resetMarketEntry(res.Data);
      window.localStorage.setItem("entry", JSON.stringify(result));
    }
  });
}

// 汇率转换 
export function priceExchange(price, type, status) {
  //console.log(price, type,status,123123123)
  /* 汇率转换 */
  let result = VueCookie.get("CardExchange") || "";
  result = JSON.parse(result);
  let newPice = 0;
  //console.log(price > 0,price)
  if (price > 0) {
    if (type == "USD") {
      /* 转美金或者澳门元 */
      newPice = status ? (price * (result["u"] + result["c"])) : (price * (result["u"] + result["c"])).toFixed(2); //四舍五入
      //console.log(newPice)
    } else {
      /* 转人民币 */
      newPice = status ? (price / (result["u"] + result["c"])) : (price / (result["u"] + result["c"])).toFixed(2);
    }
  } else {
    newPice = status ? price : price.toFixed(2);
  }
  return newPice;
}
// 转utc时间  美国或者北京时间
export function setUTC(val, i, type) {

  var date = new Date(val);
  // 判断传进来的时间是否是北京时间
  var now = new Date();
  now = moment(now)
    .format("ZZ")
    .substring(0, 3);
  now = Number(now);
  if (type == "cn") {
    i = i + now + now;
    // if (now != 8) {
    //   console.log(now)
    // }
  } else {
    i = now
  }
  var len = date.getTime();
  var offset = date.getTimezoneOffset() * 60000;
  var utcTime = len + offset;
  var newTime = new Date(utcTime + 3600000 * i);
  return newTime;
}
// 设置时间格式 undefined:标准时间带时区、0标准时间没秒数带时区
export function getTime(val, i, type, country) {
  //console.log(type)
  var newTime = setUTC(val, i, country);
  var data = "";
  if (type == undefined || type == null || type == "") {
    var time = moment(newTime).format("MMM DD, YYYY HH:mm:ss");
    var cmt = "";
    // switch (i) {
    //   case -8:
    //     cmt = "PST";
    //     break;
    //   case 8:
    //     cmt = "CCT";
    //     break;
    // }
    data = time + " " + cmt;
  } else if (type == 0) {
    var time = moment(newTime).format("MMM DD, YYYY HH:mm");
    var cmt = "";
    // switch (i) {
    //   case -8:
    //     cmt = "PST";
    //     break;
    //   case 8:
    //     cmt = "CCT";
    //     break;
    // }
    data = time + " " + cmt;
  } else if (type == 1) {
    data = moment(newTime).format("MMM DD, YYYY");
  } else if (type == 2) {
    data = moment(newTime).format("MM-DD-YYYY");
  } else if (type == 3) {
    let a1 = moment(newTime).format("MMM DD, YYYY");
    let a2 = moment(newTime).format("HH:mm:ss");
    var cmt = "";
    data = a1 + "|" + a2 + " " + cmt;
  } else if (type == 4) {
    let a1 = moment(newTime).format("MMM DD, YYYY");
    data = a1
    let nowDate = setUTC(new Date().getTime(), -8) // 当前时间    newTime//数据时间
    let TimeDate = { nowYear: nowDate.getFullYear(), nowMonth: nowDate.getMonth(), dateYear: newTime.getFullYear(), dateMonth: newTime.getMonth() }
    if (TimeDate.nowYear - TimeDate.dateYear > 0) {
      var num = (TimeDate.nowYear - TimeDate.dateYear)
      data = num + ' year' + (num > 1 ? 's' : '') + ' ago'
    } else {
      if (TimeDate.nowMonth - TimeDate.dateMonth > 0) {
        var num = (TimeDate.nowMonth - TimeDate.dateMonth)
        data = num + ' month' + (num > 1 ? 's' : '') + ' ago'
      } else {
        data = a1
      }
    }
  }
  return data;
}
// 获取快速出价对应的key
export function getBid(val) {
  let bid = enumInfo.cardhobby.place;
  let key = "";
  bid.map(res => {
    if (val >= priceExchange(bid[9].min, "USD", 1)) {
      key = priceExchange(bid[9].key, "USD", 1);
    } else if (
      priceExchange(res.min, "USD", 1) <= val &&
      val <= priceExchange(res.max, "USD", 1)
    ) {
      key = priceExchange(res.key, "USD", 1);
    }
  });
  return key;
}
// 关注商品或店家 val 0:商品，1:店家
export function setAttention(id, val) {
  let user = getInfo();
  let info = val != 0 ? { selluserid: id } : { commodityid: id };
  let data = {
    memberid: user.MappingUserId,
    token: user.ChineseToken,
    operator_id: user.MappingUserId
  };
  data = Object.assign({}, data, info);
  post(apiInterface.Interface.SetAttention, qs.stringify(data)).then(res => {});
}
export function isAuthCookie(type) {
  let time = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
  if (type) {
    VueCookie.set('CardAuth', true, { expires: time });
  } else {
    let info = VueCookie.get("CardAuth");
    // console.log('info', info)
    if (info != null && info.length > 0) {
      return info
    }
    return false
  }
}
// 加法
export function numAdd(num1, num2) {
  var baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (numMulti(num1, baseNum) + numMulti(num2, baseNum)) / baseNum;
}
// 减法
export function numSub(num1, num2) {
  var baseNum, baseNum1, baseNum2;
  var precision;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2;
  return (
    (numMulti(num1, baseNum) - numMulti(num2, baseNum)) /
    baseNum
  ).toFixed(precision);
}
// 乘法
export function numMulti(num1, num2) {
  var baseNum = 0;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {}
  return (
    (Number(num1.toString().replace(".", "")) *
      Number(num2.toString().replace(".", ""))) /
    Math.pow(10, baseNum)
  );
}
// 除法
export function numDiv(num1, num2) {
  var baseNum1 = 0,
    baseNum2 = 0;
  var baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * (Math.pow(10, baseNum2 - baseNum1));
}
// 获取屏幕宽度
export function GetWindowsWidth() {
  let w_width = document.documentElement.clientWidth;
  return w_width;
}
// 向上取整
export function numCeil(val) {
  //console.log(val, 'val')
  let num = val;
  // if (num >= 1) {
  //   num = Math.ceil(num)
  // } else {
  //   let baseNum = num.toString().split(".")[1]
  //   if (baseNum.length > 2) {
  //     num = '0.' + (Number(baseNum.substring(0, 2)) + 1)
  //     num = Number(num)
  //   }
  // }
  return Math.ceil(val);
}
//标题截取
export function titleSubstring(data, all) {
  //console.log(val, 'val')
  var titleVal = "";
  if (data) {
    titleVal = data.length > 50 && !all ? data.substring(0, 50) + "..." : data;
  }
  return titleVal;
}
// 网易云信
export function GoYunXin(userInfo, sellerId, cid, type) {
  // window.open(
  //   "../../static/Yunxin/im/main.html?account=" +
  //   userInfo.WyAccId +
  //   "&pwd=" +
  //   userInfo.WyToken +
  //   "&toaccount=" +
  //   sellerId);
  var tName = ""
  if (cid || type) {
    tName = "&id=" + cid + "&type=" + type;
  }
  window.open("https://chat.cardhobby.com/?account=" + userInfo.WyAccId + "&secret=" + userInfo.WyToken + "&to=" + sellerId + "&chat=true&token=" + userInfo.ChineseToken + "&lag=en" + tName);
}
// logout
export function toLogout(val) {
  VueCookie.delete("cardUser", { domain: domain });
  VueCookie.delete("CardAuth", { domain: domain });
  window.location.href = "/";
}
// 去除emoji表情，type 0:回车换行,type 1:回车换行空格
export function isEmoji(val, type) {
  let value = val;
  value = value.replace(
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
    ""
  );
  value = value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
  value = value.replace(/[\uE000-\uF8FF]/g, "");
  if (type === 0) {
    //禁止回车换行
    value = value.replace(/<\/?.+?>/g, "");
    value = value.replace(/[\r\n]/g, "");
  }
  if (type === 1) {
    value = value.replace(/\s+/g, "");
    value = value.replace(/<\/?.+?>/g, "");
    value = value.replace(/[\r\n]/g, "");
  }
  return value;
}
// 支付跳转
export function goPay(url, val) {
  let data = apiInterface.Interface[url] + val
  //console.log(data,'goPay')
  //return
  window.location.href = data
}
//分享 name=>f:Facebook,t:Twitter,  url=>对应分享的url
export function toShare(name, obj, url) {
  //console.log('obj', obj)
  let sharePic = ""; //分享的图片，要绝对地址
  let shareTxt = "I’ve bought a card on card hobby to earn this voucher. I’m sharing it to you so you can buy at discounts in card hobby B2C store. Please click to claim it."; // 分享内容
  let shareTitle = "I’ve bought a card on card hobby to earn this voucher. I’m sharing it to you so you can buy at discounts in card hobby B2C store. Please click to claim it."; // 分享标题
  if (obj.length > 0) {
    sharePic = obj[0]['TitImg']; //分享的图片，要绝对地址
    shareTxt = obj[0]['Title']; // 分享内容
    shareTitle = obj[0]['Title']; // 分享标题
  }
  let shareUrl =
    encodeURIComponent(url) +
    "&text=" +
    encodeURIComponent(shareTitle + "\n" + shareTxt) +
    "&display=popup&ref=plugin&src=share_button"; // 分享的总链接
  let shareName = obj[0]['Title'] || '4';
  let shareBody =
    "height=500,width750,top=" +
    (document.body.offsetHeight / 2 - 250) +
    ",left=" +
    (document.body.offsetWidth / 2 - 375) +
    ",toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no";
  if (name == "f") {
    shareName = "facebook";
    window.open(
      "https://m.facebook.com/sharer/sharer.php?u=" + shareUrl,
      shareName,
      shareBody
    );
  } else if (name == 't') {
    shareName = "twitter";
    window.open(
      "http://twitter.com/share?url=" + shareUrl,
      shareName,
      shareBody
    );
  }
}

//选择多语言
export function exchangeLang() {
  let isZh = localStorage.getItem('lang') ?
    localStorage.getItem('lang') :
    'en'

  location.replace() //刷新网页
}

export function throttle(fn, time) {
  let timer = null
  time = time || 1000
  return function(...args) {
    if (timer) {
      return
    }
    const _this = this
    timer = setTimeout(() => {
      timer = null
    }, time)
    fn.apply(_this, args)
  }
}
/** 返回國家區域枚舉
 * 
 *  code: 國家區域code
 * 
 **/
export function getAreaDetail(code) {
  const areaDetail = enumInfo.cardhobby.AreaData
  return areaDetail.filter((arr) => {
    return arr.areaCode == code
  })

}
/** 支付方式判断  地点不同拿不同的支付方式 
 * 
 *  obj: 支付列表,
 *  code: 买家所在地,
 *  payName: 需要去除的支付方式名称,
 * 
 **/
export function setPayList(obj, code, payName) {
  let data = obj
  let payEnum = enumInfo.cardhobby.paylist
  let isPay = { ispay: false, num: 0 };
  data.map((item, i) => {
    item.isPrice=true;
    item.LowerName = item.ChannelName.toLowerCase()
    for (var key in payEnum) {
      if (item.LowerName == key) {
        item.IsGuarantee = payEnum[key]
      }
    }
    //console.log(item,'item')
    // mplay song
    if (code.MemberSource == 'MO') {
      if (item.LowerName == payName) {
        isPay.isPay = true;
        isPay.num = i;
      }
    }
    // mplay song ed
    // 
    // if(payName){
    //   if (item.LowerName == payName) {
    //     isPay.isPay = true;
    //     isPay.num = i;
    //   }
    // }
  })
  if (isPay.isPay) {
    data.splice(isPay.num, 1)
  }

  return data
}

export function getAreaForSymbol(obj, type) {
  var area = obj ? obj.MemberSource : 'US'
  var areaData = $enumInfo.AreaData.filter(res => {
    return (res.areaCode == area)
  })
  if (type == 'Checkout' || type == 'Warehouse') {
    if (areaData.length > 0) {
      return areaData[0].areaSymbol
    } else {
      return 'USD'
    }
  }
  return 'USD'
}
export function saveBrowseTime(id, mid) {
  let data = { Id: id, MemberId: mid }
  post(apiInterface.Interface.SaveBrowseTime, data).then(res => {})
}

//
export function setMeta(name, val, type) {
  let metaapp = document.querySelector('head > meta[name="' + name + '"]')
  let oldcontent = metaapp.content
  metaapp.content = val
  if (type) {
    metaapp.content = oldcontent + val
  }
}

export function prompt(orderId){
  MessageBox.prompt(i18n.t('alert.PurchaseDetails'), i18n.t('base.DownloadPurchaseDetails'), {
    lockScroll:false,
    confirmButtonText: i18n.t('base.confirm'),
    cancelButtonText: i18n.t('base.cancel'),
    inputPlaceholder:i18n.t('rules.enterEmali'),
    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
    inputErrorMessage: i18n.t('rules.invalidEmailAgain'),
  }).then(({ value }) => {
    var data = { Email: value,OrderId:orderId }
    get(apiInterface.Interface.SendOrderInfoToEmail, data).then(res => {
      if (res.Result != 0) {
      }
    });
  }).catch(() => {      
  });
}



// WEBPACK FOOTER //
// ./src/api/public.js